import { Auth } from "aws-amplify";
import Cookies from "js-cookie";
import awsmobile from "../aws-exports";

const MAX_TOKEN_RETRIES = 3;

let inFlightTokenPromise = null;
let signOutPromise = null;

const clearAuthCookies = () => {
  const cookieSettings = awsmobile?.cookieStorage;
  const cookieOptions = cookieSettings?.path || cookieSettings?.domain
    ? { path: cookieSettings.path, domain: cookieSettings.domain }
    : undefined;

  Object.keys(Cookies.get()).forEach((key) => {
    Cookies.remove(key, cookieOptions);
  });
};

export const signOutAndClearAuthState = async (error, options = {}) => {
  const { rethrow = true } = options;

  if (!signOutPromise) {
    signOutPromise = Auth.signOut({ global: true })
      .catch((signOutError) => {
        console.error("Error signing out after auth failure:", signOutError);
      })
      .finally(() => {
        clearAuthCookies();
        signOutPromise = null;
      });
  }

  await signOutPromise;

  if (rethrow) {
    throw error;
  }
};

const loadAccessToken = async () => {
  for (let attempt = 0; attempt < MAX_TOKEN_RETRIES; attempt += 1) {
    const session = await Auth.currentSession();
    const jwtToken = session?.getAccessToken?.()?.getJwtToken?.();

    if (jwtToken) {
      return `Bearer ${jwtToken}`;
    }
  }

  return signOutAndClearAuthState(new Error("Missing access token after retries"));
};

const getAccessToken = async () => {
  if (!inFlightTokenPromise) {
    inFlightTokenPromise = loadAccessToken()
      .catch((error) => {
        console.error("Error retrieving access token:", error);
        throw error;
      })
      .finally(() => {
        inFlightTokenPromise = null;
      });
  }

  return inFlightTokenPromise;
};

export { clearAuthCookies, getAccessToken };